import React from 'react';
import { Alert, Box, Chip, Paper, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import MaterialSymbol from '../common/MaterialSymbol';
import type { PlatformSettings } from '../../types';

/** Secrets bleiben Env: hier nur gesetzt/fehlt, nie der Wert. */
const EnvironmentTab: React.FC<{ data: PlatformSettings }> = ({ data }) => {
    const translate = useTranslate();

    return (
        <Box sx={{ display: 'grid', gap: 3 }}>
            <Alert severity="info">{translate('platformSettings.environment.intro')}</Alert>
            <Paper sx={{ p: 2.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{translate('platformSettings.environment.secrets')}</Typography>
                {data.environment.secrets.map((s) => (
                    <Box key={s.name} data-testid={`secret-${s.name}`} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, py: 0.75, borderBottom: '1px solid var(--oa-divider)' }}>
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{s.label}</Typography>
                            <Typography variant="caption" sx={{ color: 'var(--oa-text-2)', fontFamily: 'monospace' }}>{s.name}</Typography>
                        </Box>
                        <Chip
                            size="small"
                            variant="outlined"
                            icon={<MaterialSymbol name={s.set ? 'check_circle' : 'warning'} size={16} />}
                            label={translate(s.set ? 'platformSettings.environment.set' : 'platformSettings.environment.missing')}
                        />
                    </Box>
                ))}
            </Paper>
            <Paper sx={{ p: 2.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{translate('platformSettings.environment.values')}</Typography>
                {data.environment.values.map((v) => (
                    <Box key={v.name} sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '220px 1fr' }, gap: { xs: 0, sm: 2 }, py: 0.75 }}>
                        <Typography variant="body2" sx={{ color: 'var(--oa-text-2)', fontFamily: 'monospace' }}>{v.name}</Typography>
                        <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>{v.value || '–'}</Typography>
                    </Box>
                ))}
            </Paper>
        </Box>
    );
};

export default EnvironmentTab;
